import React from 'react';
import PropTypes from 'prop-types';
import styles from './SubSection.module.scss';
import VARIANTS from './variants';

const SubSection = ({
  children,
  description = null,
  title,
  linkedTitle = null,
  link = null,
  extraHeaderClass = '',
  variant = null,
}) => {
  let variantHeaderClass = styles[extraHeaderClass] || '';
  if (description) variantHeaderClass += ` ${styles['header--with-description']}`;
  if (variant) variantHeaderClass += ` ${styles[`header${VARIANTS[variant]}`]}`;
  const variantSectionClass = variant ? `${styles[`subsection${VARIANTS[variant]}`]}` : '';
  const headerStyle = `${styles.header} ${variantHeaderClass}`;
  const sectionStyle = `${styles.subsection} ${variantSectionClass}`;

  return (
    <section className={sectionStyle}>
      <h2 className={`heading-01 ${headerStyle}`}>
        <span className={styles.accent} />
        <span className={styles.title}>
          {title}
          {linkedTitle && link && (
            <>
              &nbsp;<a href={link}>{linkedTitle}</a>
            </>
          )}
        </span>
      </h2>
      {/* eslint-disable-next-line max-len */}
      {description && <p className={styles.subsection__description} dangerouslySetInnerHTML={{ __html: description }} />}
      {children}
    </section>
  );
};

SubSection.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  linkedTitle: PropTypes.string,
  link: PropTypes.string,
  extraHeaderClass: PropTypes.string,
  variant: PropTypes.string,
};

export default SubSection;
